module.exports = __webpack_public_path__ + "static/media/power-def2.4b143c36.png";